import React, { createContext, useState } from 'react';

const ChartsContext = createContext();

export const ChartsProvider = ({ children }) => {
    const [updateTime, setUpdateTime] = useState(0);
    const [selectedEvent, setSelectedEvent] = useState('event1'); // 'event1' for 歲末祈福法會, 'event2' for 新春合禮團拜會
    const [totalEntries, setTotalEntries] = useState(0);
    const [volunteers, setVolunteers] = useState(0);
    const [englishXlation, setEnglishXlation] = useState(0);
    const [cantoneseXlation, setCantoneseXlation] = useState(0);
    const [do3R5P, setDo3R5P] = useState(0);
    const [shuttleBus, setShuttleBus] = useState(0);
    const [checkIns, setCheckIns] = useState(0);
    const [registrationPerDay, setRegistrationPerDay] = useState(0);
    const [checkin3R5P,setCheckin3R5P] = useState(0)
    const [totalToday, setTotalToday] = useState(0)
    const [relativesCount, setRelativesCount] = useState(0)
    const [totalHeadCount, setTotalHeadCount] = useState(0)
    const [checkInGroupSizeTotal, setCheckInGroupSizeTotal] = useState(0)
    
    // BudhaBath specific variables
    const [morningCount, setMorningCount] = useState(0);
    const [afternoonCount, setAfternoonCount] = useState(0);
    const [allDayCount, setAllDayCount] = useState(0);
    const [flowersCount, setFlowersCount] = useState(0);

    // New Year event specific variables
    const [totalEntriesEvent1, setTotalEntriesEvent1] = useState(0)
    const [totalEntriesEvent2, setTotalEntriesEvent2] = useState(0)
    const [totalTodayEvent1, setTotalTodayEvent1] = useState(0)
    const [totalTodayEvent2, setTotalTodayEvent2] = useState(0)
    const [totalHeadCountEvent1, setTotalHeadCountEvent1] = useState(0)
    const [totalHeadCountEvent2, setTotalHeadCountEvent2] = useState(0)
    const [checkInGroupSizeTotalEvent1, setCheckInGroupSizeTotalEvent1] = useState(0)
    const [checkInGroupSizeTotalEvent2, setCheckInGroupSizeTotalEvent2] = useState(0)
    const [registrationPerDayEvent1, setRegistrationPerDayEvent1] = useState({})
    const [registrationPerDayEvent2, setRegistrationPerDayEvent2] = useState({})
    const [scroll1,setScoll1] = useState(0)
    const [scroll2,setScoll2] = useState(0)
    const [scroll3,setScoll3] = useState(0)
    const [scroll4,setScoll4] = useState(0)
    const [scroll5,setScoll5] = useState(0)
    const [scroll6,setScoll6] = useState(0)
    const [scroll7,setScoll7] = useState(0)
    const [scroll8,setScoll8] = useState(0)
    const [scroll9,setScoll9] = useState(0)
    const [scroll10,setScoll10] = useState(0)
    const [perfectAttendeesCount,setPerfectAttendeesCount] = useState(0)

    const setChartsData = (data) => {
        setVolunteers(data.volunteers || 0);
        setEnglishXlation(data.englishXlation || 0);
        setCantoneseXlation(data.cantoneseXlation || 0);
        setDo3R5P(data.do3R5P || 0);
        setShuttleBus(data.shuttleBus || 0);
        setTotalEntries(data.totalEntries || 0);
        setCheckIns(data.checkIns || 0);
        setRegistrationPerDay(data.registrationPerDay || 0);
        setCheckin3R5P(data.checkin3R5P || 0);
        setTotalToday(data.totalToday || 0);
        setRelativesCount(data.relativesCount || 0);
        setTotalHeadCount(data.totalHeadCount || 0);
        setCheckInGroupSizeTotal(data.checkInGroupSizeTotal || 0);
        
        // BudhaBath
        setMorningCount(data.morningCount || 0);
        setAfternoonCount(data.afternoonCount || 0);
        setAllDayCount(data.allDayCount || 0);
        setFlowersCount(data.flowersCount || 0);

        // New Year event specific data - map API response fields
        // API returns: headcountEvent1, headcountEvent2, checkInGroupSizeEvent1, checkInGroupSizeEvent2
        // API also returns: totalTodayEvent1, totalTodayEvent2, totalEntriesEvent1, totalEntriesEvent2
        // These are calculated by the backend, no frontend calculation needed
        setTotalEntriesEvent1(
            data.totalEntriesEvent1 || 
            data.event1?.totalEntries || 
            data.event1?.totalEntriesEvent1 || 
            0
        );
        setTotalEntriesEvent2(
            data.totalEntriesEvent2 || 
            data.event2?.totalEntries || 
            data.event2?.totalEntriesEvent2 || 
            0
        );
        setTotalTodayEvent1(
            data.totalTodayEvent1 || 
            data.event1?.totalToday || 
            data.event1?.totalTodayEvent1 || 
            0
        );
        setTotalTodayEvent2(
            data.totalTodayEvent2 || 
            data.event2?.totalToday || 
            data.event2?.totalTodayEvent2 || 
            0
        );
        setTotalHeadCountEvent1(
            data.totalHeadCountEvent1 || 
            data.headcountEvent1 ||  // API field name
            data.event1?.totalHeadCount || 
            data.event1?.totalHeadCountEvent1 || 
            0
        );
        setTotalHeadCountEvent2(
            data.totalHeadCountEvent2 || 
            data.headcountEvent2 ||  // API field name
            data.event2?.totalHeadCount || 
            data.event2?.totalHeadCountEvent2 || 
            0
        );
        setCheckInGroupSizeTotalEvent1(
            data.checkInGroupSizeTotalEvent1 || 
            data.checkInGroupSizeEvent1 ||  // API field name
            data.event1?.checkInGroupSizeTotal || 
            data.event1?.checkInGroupSizeTotalEvent1 || 
            0
        );
        setCheckInGroupSizeTotalEvent2(
            data.checkInGroupSizeTotalEvent2 || 
            data.checkInGroupSizeEvent2 ||  // API field name
            data.event2?.checkInGroupSizeTotal || 
            data.event2?.checkInGroupSizeTotalEvent2 || 
            0
        );
        setRegistrationPerDayEvent1(
            data.registrationPerDayEvent1 || 
            data.event1?.registrationPerDay || 
            {}
        );
        setRegistrationPerDayEvent2(
            data.registrationPerDayEvent2 || 
            data.event2?.registrationPerDay || 
            {}
        );
        setScoll1(data.scroll1 || 0);
        setScoll2(data.scroll2 || 0);
        setScoll3(data.scroll3 || 0);
        setScoll4(data.scroll4 || 0);
        setScoll5(data.scroll5 || 0);
        setScoll6(data.scroll6 || 0);
        setScoll7(data.scroll7 || 0);
        setScoll8(data.scroll8 || 0);
        setScoll9(data.scroll9 || 0);
        setScoll10(data.scroll10 || 0);
        setPerfectAttendeesCount(data.perfectAttendeesCount || 0);
    };

    return (
        <ChartsContext.Provider value={{
            updateTime,
            setUpdateTime,
            selectedEvent,
            setSelectedEvent,
            totalEntries,
            setTotalEntries,
            volunteers,
            setVolunteers,
            englishXlation,
            setEnglishXlation,
            cantoneseXlation,
            setCantoneseXlation,
            do3R5P,
            setDo3R5P,
            shuttleBus,
            setShuttleBus,
            checkIns,
            setCheckIns,
            setChartsData,
            registrationPerDay,
            setRegistrationPerDay,
            checkin3R5P,
            setCheckin3R5P,
            totalToday,
            setTotalToday,
            relativesCount,
            setRelativesCount,
            totalHeadCount,
            setTotalHeadCount,
            checkInGroupSizeTotal,
            setCheckInGroupSizeTotal,
            // BudhaBath specific values
            morningCount,
            setMorningCount,
            afternoonCount,
            setAfternoonCount,
            allDayCount,
            setAllDayCount,
            flowersCount,
            setFlowersCount,
            // New Year event specific values
            totalEntriesEvent1,
            setTotalEntriesEvent1,
            totalEntriesEvent2,
            setTotalEntriesEvent2,
            totalTodayEvent1,
            setTotalTodayEvent1,
            totalTodayEvent2,
            setTotalTodayEvent2,
            totalHeadCountEvent1,
            setTotalHeadCountEvent1,
            totalHeadCountEvent2,
            setTotalHeadCountEvent2,
            checkInGroupSizeTotalEvent1,
            setCheckInGroupSizeTotalEvent1,
            checkInGroupSizeTotalEvent2,
            setCheckInGroupSizeTotalEvent2,
            registrationPerDayEvent1,
            setRegistrationPerDayEvent1,
            registrationPerDayEvent2,
            setRegistrationPerDayEvent2,
            scroll1,
            scroll2,
            scroll3,
            scroll4,
            scroll5,
            scroll6,
            scroll7,
            scroll8,
            scroll9,
            scroll10,
            perfectAttendeesCount
        }}>
            {children}
        </ChartsContext.Provider>
    );
};

export default ChartsContext;
